module.exports = __webpack_public_path__ + "img/pin-battery-red@3x.5796bfde.png";